import { observer } from "mobx-react-lite";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { storeContext } from "../../../store/root-store";
import { EventComp } from "./EventComponents/EventComp";
import { MyCustomScroll } from "../../common/MyCustomScroll";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { DateButtons } from "../../../enums/DateButtons";
import { Settings } from "../../../store/Settings";
import { AdminService } from "../../../services/AdminService";
import { EmptyPlaceholder } from "./EmptyPlaceholder";
import GptScroll from "../checkPage/GptScroll";
import { CheckScrollElement } from "./CheckScrollElement";
import {
  EventViewManagmentPanel,
  ViewComponents,
} from "./EventPreviewManagmentPanel/EventViewManagmentPanel";
import { VerticalEvent } from "./EventComponents/VerticalEvent";
import { DatesPanel } from "./panels/DatesPanel";
import { usePageElements } from "../../../hooks/usePageElements";
import { TagsPanel } from "./panels/TagsPanel/TagsPanel";
import { AdminDatesPanel } from "./panels/TagsPanel/AdminDatesPanel";
import { Loader } from "../../common/Loader";
import { SearchPanel } from "./panels/searchPanel/SearchPanel";
const EventMemo = React.memo(EventComp);
export interface IListOfEvents {
  loadEvents: (page: number) => Promise<{ hasMore: boolean }>;
}
export const ListOfEvents = observer(({ loadEvents }: IListOfEvents) => {
  const {
    eventsStore,
    settingsGl,
    filterTagGl,
    filterDatesGl,
    adminDateFilterGl,
  } = useContext(storeContext);
  const [firstLoad, setFirstLoad] = useState<boolean>(false);
  const contWrapper = useRef<HTMLDivElement | null>(null);
  const { getHeightForScroll } = usePageElements();
  const scrollElementHeight = getHeightForScroll();

  const [hasMore, setHasMore] = useState<boolean>(false);

  const nav = useNavigate();

  const testEvents = () => {
    return () => {
      return loadEvents;
    };
  };

  const getEvents = () => {
    // return () => {
    //   loadEvents;
    // };
    const timeInterval = Settings.getTimeInterval(settingsGl.currentDayFilter);
    const selectedEvents = settingsGl.selectedListOfEvents;
    const showOnlyUnique = settingsGl.showOnlyUnique;
    return async (currentPage: number = 0) => {
      return await eventsStore.getListOfPreviewEvents(
        timeInterval.startSec,
        timeInterval.finishSec,
        // settingsGl.selectedTag?.id ? [settingsGl.selectedTag.id] : [],
        filterTagGl.listOfSelectedTags.map((el) => el.id),
        currentPage,
        Settings.chunkLength,
        showOnlyUnique,
        settingsGl.currentDayFilter,
        timeInterval,
        filterDatesGl.listOfSelecedDates,
        Array.from(adminDateFilterGl.listOfSelectedDates)
      );
      // return res;
    };
  };
  const onSearch = async (query: string) => {
    // alert("Отправляю запрос" + settingsGl.searchQuery);
    // const subDates = [...filterDatesGl.listOfSelecedDates];
    settingsGl.clearAllFilters();
    // filterDatesGl.listOfSelecedDates = subDates;
    settingsGl.searchQuery = query;
    // settingsGl.searchQuery = query;
    await getEvents()();
  };
  const onChangeSearchValue = (newValue: string) => {
    settingsGl.searchQuery = newValue;
  };

  const onFirstLoad = async () => {
    eventsStore.listOfPreviewEvents = [];
    settingsGl.scrollElementHeight = getHeightForScroll();
    const loadResult = await loadEvents(settingsGl.currentPage);
    setHasMore(loadResult.hasMore);
  };

  useEffect(() => {
    onFirstLoad();
  }, []);

  return (
    <div className="">
      <SearchPanel
        key={settingsGl.searchQuery}
        baseValue={settingsGl.searchQuery}
        style={{ paddingTop: 0.5 + "rem" }}
        // className=""
        onChangeQuery={onChangeSearchValue}
        onSearch={onSearch}
      ></SearchPanel>

      <div className="d-flex">
        <DatesPanel></DatesPanel>
      </div>
      {/* <TagsPanel></TagsPanel> */}
      <div
        ref={contWrapper}
        // style={{ border: 1 + "px solid black" }}
      >
        <GptScroll
          // key={+settingsGl.scrollKeyCounter}
          hasMoreGl={hasMore}
          reload={settingsGl.scrollKeyCounter}
          // height={87 + "vh"}
          minHeight={50 + " vh"}
          height={settingsGl.scrollElementHeight - 3 + "px"}
          startPage={settingsGl.currentPage}
          onScroll={getEvents()}
          // onScroll={testEvents()()}
          onFirstLoadFinish={(firstLoad) => {
            setFirstLoad(firstLoad);
          }}
        >
          <>
            {!eventsStore.isEventsLoaded && <Loader></Loader>}
            <div className="row">
              {eventsStore.listOfPreviewEvents.map((el, index, ar) => {
                return (
                  <div key={el.id} className="col-md-6 col-12 col-sm-12 mt-2">
                    {settingsGl.currentComponentViewState ===
                      ViewComponents.textOverImg && (
                      <EventComp
                        onClick={() => {}}
                        key={el.id}
                        event={el}
                        // className="col-6 col-sm-6 mt-2"
                        className=""
                      />
                    )}
                    {/* {index == ar.length - 1 && (
                    <div
                      key={el.id}
                      className="mobile-nav-margin col-12 col-sm-12 mt-2"
                    ></div>
                  )} */}
                  </div>
                );
              })}
              {/* {!settingsGl.selectedTag.id && firstLoad && (
              <EmptyPlaceholder selectedTag={settingsGl.selectedTag} />
            )} */}
            </div>
          </>
        </GptScroll>
      </div>
    </div>
  );
});
